import {
    apiRequest,
    create,
    detail
} from "../../../../../services/adapters/kepegawaian/pengajuanOnlineService"

class CreateRepository {
    
    fetchCreate = async (query) => {
        return await apiRequest("post", create, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", detail, {
            params: query
        }, true)
    }


}

export default CreateRepository